import { render } from "./GroupAttendanceReport.vue?vue&type=template&id=6b660b69&scoped=true"
import script from "./GroupAttendanceReport.vue?vue&type=script&lang=js"
export * from "./GroupAttendanceReport.vue?vue&type=script&lang=js"

import "./GroupAttendanceReport.vue?vue&type=style&index=0&id=6b660b69&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b660b69"]])

export default __exports__